import { type ReactElement } from 'react';

import { Button } from '@/components/ui/button';

/**
 * Fallback UI when the root error boundary catches an unhandled error.
 */
export function SentryErrorFallback(): ReactElement {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-muted/50 p-4">
      <h1 className="text-2xl font-bold">Something went wrong</h1>
      <p className="text-center text-sm text-muted-foreground">Please reload the page.</p>
      <Button type="button" onClick={() => window.location.reload()}>
        Reload
      </Button>
    </div>
  );
}
